import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'AccountSelectLinkedCmsModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      // テーブルオプション
      tableColumns: [
        'checkbox',
        'linkedCmsMstId',
        'linkedCmsName',
        // 'linkedCmsStatus'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          linkedCmsMstId: 'CMS ID',
          linkedCmsName: 'CMS名',
          linkedCmsStatus: 'ステータス'
        },
        columnsClasses: {
          checkbox: 'wp-3',
          linkedCmsMstId: '',
          linkedCmsName: '',
          linkedCmsStatus: ''
        },
        sortable: [
          'linkedCmsMstId',
          'linkedCmsName',
          'linkedCmsStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('連携CMS'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      serviceLinkedCmsModel: state => state.accountSelectLinkedCmsModal.serviceLinkedCmsModel,
      active: state => state.accountSelectLinkedCmsModal.active,
      serviceId: state => state.accountSelectLinkedCmsModal.serviceId,
      // form
      values: state => state.userForm.values
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableCheckbox() {
      return linkedCmsMstUuid => {
        return this.checkList.length
          ? this.checkList.indexOf(linkedCmsMstUuid) === -1
          : false
      }
    },
    disableDetermineButton () {
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'accountSelectLinkedCmsModal/loadModel',
      hide: 'accountSelectLinkedCmsModal/hide'
    }),
    ...mapMutations({
      setInputValue: 'userForm/setInputValue',
    }),

    init () {
      this.loading = true

      // 選択済み連携CMSのIDをチェックリストに格納
      if (this.values.inpCmsList &&
        this.values.inpCmsList.length) {
        this.checkList = $.extend(true, [], this.values.inpCmsList)
      }

      //
      let serviceLinkedCmsParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceLinkedCmsParams: serviceLinkedCmsParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.serviceLinkedCmsModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.linkedCmsMstUuid
        case 'linkedCmsStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    determineValue () {
      console.log('check : ', this.checkList)
      this.setInputValue({
        key: 'inpCmsList',
        value: this.checkList
      })
      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}